/** The red asterisk after a required field's label (platform red at 50%).
 *  Hidden from screen readers: the field itself carries the required state. */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-[#E4002B]/50">
      {" "}*
    </span>
  );
}
